import { render, staticRenderFns } from "./Full.vue?vue&type=template&id=67624663&scoped=true&"
import script from "./Full.vue?vue&type=script&lang=js&"
export * from "./Full.vue?vue&type=script&lang=js&"
import style0 from "./Full.vue?vue&type=style&index=0&id=67624663&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67624663",
  null
  
)

export default component.exports